import React, { useEffect, useState, useRef } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Stack } from '@sunwisesoftware/sunwise-ui';
import { debounce, isEmpty, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import CustomPagination from 'common/components/CustomPagination';
import { DEBOUNCE_TIME_500, TABLE_PAGE_SIZE_OPTIONS } from 'common/constants';

const ProductListItems = ({
    alliancesFilterData,
    bulkAssignProducts,
    filterData,
    filterItems,
    initialValues,
    isFetching,
    items,
    setFilterData,
}) => {
    const { t } = useTranslation();
    const { handleSubmit, reset } = useForm({
        defaultValues: initialValues,
    });
    const [selectionModel, setSelectionModel] = useState([]);
    const [currentFilterData, setCurrentFilterData] = useState(filterData);

    const handleOnFilter = useRef(
        debounce((filter) => filterItems(filter), DEBOUNCE_TIME_500),
    ).current;

    const handleClickAssignProducts = (values) =>
        bulkAssignProducts(alliancesFilterData, {
            ...values,
            products: selectionModel,
        });

    const pageSizeOptions = TABLE_PAGE_SIZE_OPTIONS;

    const columns = [
        {
            align: 'left',
            field: 'name',
            flex: 1,
            headerName: t('Product'),
            sortable: false,
        },
    ];
    const getRowHeight = () => 'auto';
    const initialState = {
        pagination: {
            paginationModel: { pageSize: TABLE_PAGE_SIZE_OPTIONS[0] },
        },
    };
    const onPaginationModelChange = (model) =>
        setFilterData((prev) => ({ ...prev, ...model }));
    const onRowSelectionModelChange = (model) => setSelectionModel(model);

    const slots = { pagination: CustomPagination };
    const slotProps = { pagination: { pageSizeOptions } };

    useEffect(() => reset(initialValues), [initialValues]);

    useEffect(() => {
        if (!isEqual(currentFilterData, filterData)) {
            handleOnFilter(filterData);
            setCurrentFilterData(filterData);
        }
    }, [filterData]);

    useEffect(() => {
        if (!isEmpty(items)) {
            const selected = items
                .filter(({ added }) => added)
                .map((item) => item.id);
            setSelectionModel(selected);
        }
    }, [items]);

    return (
        <Stack component="form">
            <DataGrid
                checkboxSelection={true}
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                getRowHeight={getRowHeight}
                initialState={initialState}
                loading={isFetching}
                onPaginationModelChange={onPaginationModelChange}
                onRowSelectionModelChange={onRowSelectionModelChange}
                pagination
                rows={items}
                selectionModel={selectionModel}
                slotProps={slotProps}
                slots={slots}
            />

            <Box textAlign="right">
                <Button
                    disabled={isEmpty(selectionModel)}
                    color="secondary"
                    onClick={handleSubmit(handleClickAssignProducts)}
                >
                    {t('Save')}
                </Button>
            </Box>
        </Stack>
    );
};

ProductListItems.propTypes = {
    alliancesFilterData: PropTypes.object,
    bulkAssignProducts: PropTypes.func,
    filterData: PropTypes.object,
    filterItems: PropTypes.func,
    initialValues: PropTypes.object,
    isFetching: PropTypes.bool,
    items: PropTypes.array,
    setFilterData: PropTypes.func,
};

export default ProductListItems;
